export default __webpack_public_path__ + "static/media/cristian-newman-tnxRFtXI9dI-unsplash.68473d15.png";